import { Assert } from './assert';

export function hexToRgb(hex: string) {
  const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})?$/i.exec(hex);
  if (result) {
    return [
      parseInt(result[1]!, 16),
      parseInt(result[2]!, 16),
      parseInt(result[3]!, 16),
      result[4] !== undefined ? parseInt(result[4]!, 16) : 255,
    ];
  } else {
    return [0, 0, 0, 255];
  }
}

function rgbToHex(rgb: number[]) {
  Assert.above(rgb.length, 2);

  let hex = '#' + componentToHex(rgb[0]!) + componentToHex(rgb[1]!) + componentToHex(rgb[2]!);

  if (rgb.length > 3) {
    hex += componentToHex(rgb[3]!);
  }

  return hex;

  function componentToHex(c: number) {
    const hex = Math.floor(c).toString(16);
    return hex.length == 1 ? '0' + hex : hex;
  }
}

export function calculateTextColor(backgroundColor: string) {
  const rgb = hexToRgb(backgroundColor);
  const bright = brightness(rgb);
  if (bright > 127.5) {
    return '#000000';
  } else {
    return '#FFFFFF';
  }
}

export function brightness(rgb: number[]) {
  const red = rgb[0]!;
  const green = rgb[1]!;
  const blue = rgb[2]!;

  return Math.sqrt(red * red * 0.299 + green * green * 0.587 + blue * blue * 0.114);
}

export function colorLuminance(hex: string, lum: number) {
  // validate hex string
  hex = String(hex).replace(/[^0-9a-f]/gi, '');
  if (hex.length < 6) {
    hex = hex[0]! + hex[0]! + hex[1]! + hex[1]! + hex[2]! + hex[2]!;
  }
  lum = lum || 0;

  // convert to decimal and change luminosity
  let rgb = '#',
    c,
    i;
  for (i = 0; i < 3; i++) {
    c = parseInt(hex.substr(i * 2, 2), 16);
    c = Math.round(Math.min(Math.max(0, c + c * lum), 255)).toString(16);
    rgb += ('00' + c).substr(c.length);
  }

  if (hex.length == 8) {
    rgb += hex[6]! + hex[7]!;
  }

  return rgb;
}

export function calculateHighlightColor(color: string) {
  const backgroundRgb = hexToRgb(color);
  const bright = brightness(backgroundRgb);
  return colorLuminance(color, bright > 210 ? -0.2 : 0.25);
}

export function calculateMutedColor(color: string) {
  const backgroundRgb = hexToRgb(color);
  const bright = brightness(backgroundRgb);
  return colorLuminance(color, bright < 110 ? 0.2 : -0.25);
}

export function interpolateColor(percent: number, colors: string[]) {
  Assert.above(colors.length, 1);

  const left = Math.floor(percent * (colors.length - 1));
  const right = Math.ceil(percent * (colors.length - 1));
  const colorLeft = colors[left];
  const colorRight = colors[right];

  const step = 1.0 / (colors.length - 1);
  const percentRight = (percent - left * step) / step;
  const percentLeft = 1.0 - percentRight;

  const leftRgb = hexToRgb(colorLeft!);
  const rightRgb = hexToRgb(colorRight!);

  const rgb = [
    leftRgb[0]! * percentLeft + rightRgb[0]! * percentRight,
    leftRgb[1]! * percentLeft + rightRgb[1]! * percentRight,
    leftRgb[2]! * percentLeft + rightRgb[2]! * percentRight,
    leftRgb[3]! * percentLeft + rightRgb[3]! * percentRight,
  ];

  const hex = rgbToHex(rgb);
  return hex;
}
